import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PerfilesService } from '../../servicios/perfiles/perfiles.service';
import { UsuariosService } from '../../servicios/usuarios/usuarios.service';
import swal from 'sweetalert2';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { HeaderService } from '../../servicios/header/header.service';

//Acordeon
import {AccordionModule} from "ng2-accordion";
declare var $: any;
@Component({
  selector: 'app-lateral',
  templateUrl: './lateral.component.html',
  styleUrls: ['./lateral.component.css']
})
export class LateralComponent implements OnInit {
  getidperfil      : any = localStorage.getItem('idperfil');  // almacena el el perfil del usuario para vaklidar si es de tipo C es cliente
  listpermisos : any;
  formFiltros  : FormGroup; //Accion para  Editar componente
  statesModulo            = new Array();
  selectedOptionModulo    : any;
  noResultModulo          = false;
  filtros                 = { modulo : '' }
  modulos                 = new Array();  //Almacena el arreglo de todos los modulos de sistema

  session = false;
  option_1 = 'Configuración';
  option_2 = 'Dashboard';
  option_3 = 'Informes';
  option_4 = 'Administración';
  option_5 = 'Incidencias';
  option_6 = 'Servicios';

  label_logout    = 'Salir';
  label_salir     = 'Salir del sistema';
  label_usuarios  = 'Usuarios';
  label_perfiles  = 'Perfiles';


  nombreUsuario : any = localStorage.getItem('nombreUsuario');
  constructor(
    private router    : Router,
    private _usuarios : UsuariosService,
    private _header   : HeaderService,
    private _perfiles : PerfilesService
  ) {}


  ngOnInit()
  {
    this.modulos = this._header.modulos;
    this.filtrosModulo();
    this._usuarios.getUserIngresado();
    // this.responsive();
    this.getPermisos();

    this.moduloFiltro();


    // $(document).off('click').on('click', function (e) {
    //     if (!$(e.target).closest('#leftMenu').hasClass('accordion')) {
    //         // $('.collapseTwo2').collapse('hide');
    //     }
    // });
  }

  onSelectModulo(event: TypeaheadMatch): void { this.selectedOptionModulo = event.item.modulo;
    this._header.rutasModule(event.item.modulo,this.listpermisos);
    this.formFiltros.reset();
  }
  typeaheadNoResultsModulo(event: boolean): void { this.noResultModulo = event; }

  clicksession(){
    this.session = this.session == true ? this.session = false : this.session = true;
  }

    /**
   * Permite obtener el listado de modulo
   * CAAA-2019-03-08
   */
    moduloFiltro(){
    if (this.modulos.length > 0)
    {
      this.statesModulo = [];
      var parametromodulo_aux = {};
      for (var i in this.modulos) {
        parametromodulo_aux[this.modulos[i]['modulo']] = this.modulos[i];
      }
      //DATALIST
      for (let i in parametromodulo_aux) {
        this.statesModulo.push({
          'modulo' : parametromodulo_aux[i].modulo,
          'infomodulo' : parametromodulo_aux[i].modulo
        });
      }
    }
  }// .obtenerComponente_filtro(tipo)



  /**
   * Permite ejecutar el responsive del menu
   * JMM-2018-09-14
   */
  // responsive()
  // {
  //   var x = document.getElementById("myTopnav");
  //   if (x.className === "topnav") {
  //       x.className += " responsive";
  //   } else {
  //       x.className = "topnav";
  //   }
  // }// .responsive()


  /**
   * Permite obtener los permisos y perfiles de usuario
   * JMM-2018-12-11
   */
  getPermisos()
  {
    this._perfiles.getPermisosUsuariosFull().subscribe((resp)=>{
      this.listpermisos = resp.data;
    });
  }

    /**
   * Permite desloguearse de la aplicación eliminando la sesión del usuario
   * JMM-2018-03-22
   */
     logout()
     {
       swal({
         title: '<div class="div_contenido_swal">Desea salir de la aplicación?</div>',
         text: "",
         type: 'warning',
         showCancelButton: true,
         confirmButtonClass: 'boton_confirm_swal',
         cancelButtonClass: 'boton_cancel_swal',
         confirmButtonText: 'Aceptar',
         cancelButtonText: 'Cancelar'
       }).then((result) => {
         if (result.value)
         {
           //Salir session del cliente
           this._usuarios.salirsessioncliente().subscribe((resp)=>{
             if (resp.error) {
                     //Eliminar datos de session del storage
                 localStorage.removeItem('usuarioid');
                 localStorage.removeItem('clave');
                 localStorage.removeItem('nombreUsuario');
                 localStorage.removeItem('cedulaUsuario');
                 localStorage.removeItem('idusuario');
                 localStorage.removeItem('idperfil');
                 localStorage.removeItem('estadonotificacion');
                 localStorage.removeItem('PATH');
                 localStorage.removeItem('nombreEmpresa');
                 localStorage.removeItem('nitEmpresa');
                 localStorage.removeItem('useringresoid');
                 localStorage.removeItem('useringresoestado');
                 localStorage.removeItem('paramdesplazamiento');
                 localStorage.removeItem('sucursalcliente');
                 localStorage.clear();

                 //Redireccionar al login
                 this.router.navigate(['/login'], { replaceUrl: true });
                 location.reload();
             }else{
               //Eliminar datos de session del storage
               localStorage.removeItem('usuarioid');
               localStorage.removeItem('clave');
               localStorage.removeItem('nombreUsuario');
               localStorage.removeItem('cedulaUsuario');
               localStorage.removeItem('idusuario');
               localStorage.removeItem('idperfil');
               localStorage.removeItem('estadonotificacion');
               localStorage.removeItem('PATH');
               localStorage.removeItem('nombreEmpresa');
               localStorage.removeItem('nitEmpresa');
               localStorage.removeItem('useringresoid');
               localStorage.removeItem('useringresoestado');
               localStorage.removeItem('paramdesplazamiento');
               localStorage.removeItem('sucursalcliente');
               localStorage.clear();

               //Redireccionar al login
               this.router.navigate(['/login'], { replaceUrl: true });
               location.reload();
             }

           });
         }
       });
     }//Fin de logout()

     filtrosModulo(){
      this.formFiltros = new FormGroup({
        'modulo'    : new FormControl(this.filtros.modulo)
      });
    }

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/lateral/lateral.component.ts